import React, { useEffect, useContext, useState, useMemo } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  formatPrice,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { useCustomHooks } from "../../../../../functions/Hooks";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";

const FgSaleOrderAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    dataPaginating,
  } = useContext(RestaurantContext);
  let { getCustomer, customerForSearch } = useContext(UserContext);
  let { foodForPOS } = useContext(FoodContext);
  const { id } = useParams();
  const { roundOffStock, qtyAmountPoints } = useCustomHooks();
  // States hook here
  //new item
  let [newItem, setNewItem] = useState({
    branch: null,
    date: new Date(),
    customer: null,
    description: "",
  });

  //new Row
  const [newRow,setNewRow]=useState([]);

  //useEffect == componentDidMount()
  useEffect(() => {
    if(!customerForSearch){
      getCustomer();
    }
  }, []);

  const getSaleItem = async () => {
    const url = BASE_URL + "/settings/finished-good-sale-order/" + parseInt(id);
    setLoading(true)
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        
        const editSaleOrder= res.data;
        if(editSaleOrder && editSaleOrder !== null){
          let docDate=new Date(editSaleOrder.document_date);
         
          setNewItem({
            ...newItem,
            date: docDate,
            invoice:editSaleOrder.document_identity,
            branch: editSaleOrder.branch,
            customer: editSaleOrder.customer,
            description:editSaleOrder?.desc ?? "",
          })
          let rowArr=[];
          if(editSaleOrder.finished_good_sale_order_detail && editSaleOrder.finished_good_sale_order_detail.length > 0){
            editSaleOrder.finished_good_sale_order_detail.map((item)=>{
              rowArr.push({
                item_id: item.item_id,
                item_name: item.item_name,
                qty:item.qty,
                rate: roundOffStock(item.price),
                amount: roundOffStock(item.amount),
                isEdit:true,
              })
            })
            setNewRow([...rowArr]);
          }
        }
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(id){
      getSaleItem()
    }
  },[id])
  
  //on change input field
  const handleDesc = (e) => {
    setNewItem({ ...newItem, description: e.target.value });
  };

  //on change input field
  const handleChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewItem({ ...newItem, branch });
  };

  //set items hook
  const handleSetItems = async (index,item) => {
    newRow[index].item_name=item;
    setNewRow([...newRow]);
  };

  //subtotal
  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return roundOffStock(rate * qty);
  };

  const totals = useMemo(() => {
    let baseTotal = 0

    if (newRow !== null) {
      newRow.forEach((item, index) => {
        const qty = parseFloat(item.qty) || 0;
        const rate = parseFloat(item.rate) || 0;
        const baseAmount = rate * qty;
        
        baseTotal += baseAmount
      });
    }
    return {
      baseTotal: roundOffStock(baseTotal),
    };
  }, [newRow]);

  //set each item qty
  const handleItemQty = (index,e) => {
    newRow[index].qty=e.target.value;
    setNewRow([...newRow]);
  };

  //set each item rate
  const handleItemRate = (index,e) => {
    newRow[index].rate=e.target.value;
    setNewRow([...newRow]);
  };

  //handle Set customer hook
  const handleSetCustomer = async(customer) => {
    setNewItem({ ...newItem, customer });
  };

  //post req of food item add
  const ingredientItemAxios = async () => {
    // setLoading(true);
    let date =
      new Date(newItem.date).getFullYear() +
      "-" +
      (new Date(newItem.date).getMonth() + 1) +
      "-" +
      new Date(newItem.date).getDate();
     

    //converting items and prices to array
    let slugArray = [];
    let duplicate = {};
    const duplicateItem = [];
    newRow.map((newIngredientItem,index) => {
      const item_id = newIngredientItem.isEdit ? newIngredientItem.item_id
      : newIngredientItem.item_name.id;
      const item_name = newIngredientItem.isEdit ? newIngredientItem.item_name
        : newIngredientItem.item_name.name;
      if(duplicate[item_id]){
        duplicateItem.push({
          item_id: item_id,
          item_name: item_name,  
        })
      }
      if(newIngredientItem.item_name === ""){
        slugArray.push();
      }else{
        duplicate[item_id] = true;
        slugArray.push({
          qty: newIngredientItem.qty,
          price: newIngredientItem.rate,
          item_id: newIngredientItem.isEdit ? newIngredientItem.item_id : newIngredientItem.item_name.id,
          item_name: newIngredientItem.isEdit ? newIngredientItem.item_name : newIngredientItem.item_name.name,
          amount: handleGetAmount(index),
        });
      }
    });

    if(duplicateItem?.length){
      toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    let formData = {
      document_date : date,
      desc : newItem.description,
      branch_id : newItem.branch?.id ?? "",
      branch_name: newItem.branch?.name ?? "",
      customer_id : newItem.customer.id,
      customer_name: newItem.customer?.name ?? "",
      total_amount: roundOffStock(totals.baseTotal),
      items : slugArray,
    }

    if(newRow.length === slugArray.length){
      setLoading(true);
      const mehtod = id ? "put" : "post";
      const endpoint = id ? ("/settings/finished-good-sale-order/" + id) : "/settings/finished-good-sale-order"
      const url = BASE_URL + endpoint ;
      try {
        const res = await axios[mehtod](url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        setLoading(false);
        toast.success(`${_t(t(id ? "Fg sale order has been updated" : "Fg sale order has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        history.push("/dashboard/manage/stock/fg-sale-order")
      } catch (error) {    
        setLoading(false);
        if(error.response.data?.status === 0){
          toast.error(`${_t(t(error.response.data?.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again later"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }else{
      toast.error(`${_t(t("Please select all dropdowns"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newItem.branch !== null &&
      newItem.customer !== null &&
      newItem.date !== null
    ) {
      if(newRow.length>0){
        ingredientItemAxios();
      }else{
        toast.error(`${_t(t("Please add orders"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    } else {
      toast.error(`${_t(t("Please fill all required fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };


  const addNewRow=()=>{
    // if(newOpeningStock.branch !== null){
    setNewRow((pre)=>[...pre,{
      item_name:"",
      qty:"",
      unit:"",
      rate:"",          
      isEdit:false,
    }])
  }

  const delRow=(index)=>{
    let row=[...newRow];
    if(index > -1){
      row.splice(index, 1);
    }
    setNewRow(row);
  }

  return (
    <>
    <Helmet>
      <title>{_t(t( id ? "Edit Fg Sale Order" :"Add Fg Sale Order"))}</title>
    </Helmet>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <div className={`${loading && "loading"}`}></div>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {dataPaginating === true ? (
                    tableLoading()
                  ) : (
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t(id ? "Edit Fg Sale Order" : "Add Fg Sale Order"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="col-12">
                          <div className="row">
                            {branchForSearch && (
                              <>                            
                                <div className="form-group col-4 mt-2">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="invoice"
                                      className="control-label"
                                    >
                                      {_t(t("Invoice #"))}
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      disabled={true}
                                      type="text"
                                      className="form-control table-text"
                                      id="invoice"
                                      name="invoice"
                                      // onChange={handleChange}
                                      value={newItem.invoice}
                                      placeholder="Auto No"
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-4 mt-2">
                                  <div className="mb-2 ">
                                    <label
                                      htmlFor="Date"
                                      className="control-label"
                                    >
                                      {_t(t("Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={newItem.date}
                                      onChange={(date) => setNewItem({...newItem, date})}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("Purchase date"))}
                                      shouldCloseOnSelect={false}
                                    />
                                  </div>
                                </div>

                                <div className="form-group mt-2 col-4">
                                  <div className="mb-1 text-left">
                                    <label
                                      htmlFor="branch"
                                      className="control-label text-truncate"
                                    >
                                      {_t(t("Branch"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch || []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newItem.branch || ""}
                                    classNamePrefix="select"
                                    onChange={handleSetBranch}
                                    maxMenuHeight="200px"
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }
                                    styles={customStyle}
                                    required
                                    isDisabled={id}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="row">
                            <div className="form-group mt-2 col-3">
                              <div className="mb-2 ">
                                <label
                                  htmlFor="supplier"
                                  className="control-label"
                                >
                                  {_t(t("Customer"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <Select
                                options={customerForSearch || []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={newItem.customer || ""}
                                classNamePrefix="select table-text"
                                onChange={handleSetCustomer}
                                //maxMenuHeight="50px"
                                placeholder={
                                  _t(t("Please select a customer")) + ".."
                                }
                                styles={customStyle}
                                required
                                isDisabled={id}
                              />
                            </div>
                            <div className="form-group mt-2 col-9">
                              <div className="mb-2">
                                <label
                                  htmlFor="description"
                                  className="control-label"
                                >
                                  {_t(t("Description"))}
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  type="text"
                                  className="form-control table-text"
                                  id="description"
                                  name="description"
                                  onChange={handleDesc}
                                  value={newItem.description}
                                  placeholder="Short description"
                                />
                              </div>
                            </div>
                          </div>                          
                            <div className="table-responsive mt-3 pr-1" style={{maxHeight:"23rem",overflow: "auto"}}>
                              <table className="table table-bordered-sm table-hover">
                                <thead className="align-middle">
                                  <tr>
                                  {newRow.length==0 ?<th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span className="t-mr-10" onClick={()=>addNewRow()}>
                                        <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                      </span>
                                    </th>:<th style={{borderBottomColor:"lightgray"}}></th>}
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border "
                                      style={{minWidth:"12rem"}}
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Name"))}
                                      </span>
                                    </th>
                                  
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                      style={{minWidth:"12rem"}}
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Rate"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Amount"))}
                                      </span>
                                    </th>
                                 
                                    {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                  </tr>
                                </thead>
                                {newRow && newRow.length>0 ?
                                <tbody className="align-middle">
                                  {newRow.map(
                                    (ingredientItem, index) => {
                                      return (
                                        <tr
                                          className="align-middle"
                                          key={index}
                                        >
                                          <td className="table-text text-capitalize align-middle text-center table-firstChild" style={{minWidth:"60px"}}>
                                            {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                              <i className="fa fa-plus-circle btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                            </span>}&nbsp;
                                            <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} 
                                            onClick={()=>{delRow(index)}}
                                            ></i>
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center table-Child">
                                            {ingredientItem.isEdit ?
                                              <input
                                                readOnly
                                                type="text"
                                                className={`form-control text-center table-Input table-text`}
                                                value={ingredientItem.item_name || ""}
                                              />
                                              :                                           
                                              <Select
                                                options={foodForPOS}
                                                getOptionLabel={(option) => option.name}
                                                getOptionValue={(option) => option.id}
                                                classNamePrefix="select table-text"
                                                onChange={(e)=>handleSetItems(index,e)}
                                                placeholder={
                                                _t(t("Please select items")) + ".."
                                                }
                                                menuPosition="fixed"
                                                styles={customStyle}
                                              />
                                            }
                                          </td>

                                          <td className="table-text text-capitalize align-middle text-center" style={{width:"15%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={ingredientItem.id}
                                            name={ingredientItem.id}
                                            onChange={(e)=>handleItemQty(index,e)}
                                            value={ingredientItem.qty}
                                            placeholder="Qty"
                                            required
                                          />
                                        </td>

                                        <td className="table-text text-capitalize align-middle text-center" style={{width:"15%"}}>
                                          <input
                                            type="number"
                                            step={qtyAmountPoints()}
                                            min="0"
                                            onKeyDown={(evt) =>
                                              ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={ingredientItem.id}
                                            name={ingredientItem.id}
                                            onChange={(e)=>handleItemRate(index,e)}
                                            value={ingredientItem.rate}
                                            placeholder="Price"
                                            required                                               
                                          />
                                        </td>
                                        <td className="table-text text-capitalize align-middle text-center">
                                         {formatPrice(handleGetAmount(index))}
                                        </td>
                                         
                                        <td className="table-text text-capitalize align-middle text-center" style={{minWidth:"60px"}}>
                                          <i className="fa fa-minus-circle cursor-pointer text-danger" style={{fontSize:"22px"}} onClick={()=>{delRow(index)}}></i>&nbsp;
                                          {index==(newRow.length-1) && <span className="t-mr-10" onClick={()=>addNewRow()}>
                                            <i className="fa fa-plus-circle cursor-pointer btn-add-icon" style={{fontSize:"22px"}} aria-hidden="true"></i>
                                          </span>}                                             
                                        </td>
                                      </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                                : null }
                                {newRow && newRow.length>0 ?
                                <tfoot className="align-middle">
                                  <tr>
                                    <th
                                      scope="col"
                                      colSpan="4"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span style={{fontWeight:500}}>
                                        {_t(t("Total"))}
                                      </span>
                                    </th>

                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      {formatPrice(totals.baseTotal)}
                                    </th>
                                    
                                    {newRow.length>0 && <th style={{borderBottomColor:"lightgray",minWidth:"60px"}}></th>}
                                  </tr>
                                </tfoot>  
                                : null }
                              </table>
                            </div>                            
                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                type="button"
                                className="btn rounded hov-btn mr-3"
                                onClick={()=>(history.push("/dashboard/manage/stock/fg-sale-order"))}
                                //   data-dismiss="modal"
                                >
                                  <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Save"))}
                                </button>                                                    
                              </div>                                                    
                          </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
  </>
  )
}

export default FgSaleOrderAction
